export default __webpack_public_path__ + "static/media/M2HairSalon-5.e73f1db2.jpg";